import { Testimonial } from '.';
import ManagerTestimonialImage1 from '@assets/manager-testimonial-image-1.jpg';
import ManagerTestimonialImage2 from '@assets/manager-testimonial-image-2.jpg';
import ManagerTestimonialImage3 from '@assets/manager-testimonial-image-3.jpg';
const ManagerTestimonials: Array<Testimonial> = [
  {
    image: ManagerTestimonialImage1,
    name: 'new_productoverview_manager.testimonial1_name',
    comment: 'new_productoverview_manager.testimonial1_comment',
    starRate: 5,
  },
  {
    image: ManagerTestimonialImage2,
    name: 'new_productoverview_manager.testimonial2_name',
    comment: 'new_productoverview_manager.testimonial2_comment',
    starRate: 5,
  },
  {
    image: ManagerTestimonialImage3,
    name: 'new_productoverview_manager.testimonial3_name',
    comment: 'new_productoverview_manager.testimonial3_comment',
    starRate: 5,
  },
];

export default ManagerTestimonials;
